import gql from "graphql-tag";

export const USER_TOTAL_POINTS_QUERY = gql`
  query rewardPoints($userId: ID) {
    rewardPoints(userId: $userId, approvalStatus: "APPROVED") {
      totalPoints
    }
  }
`;

export const USER_REWARDS_POINTS_QUERY = gql`
  query rewardPoints($userId: ID, $approvalStatus: String) {
    rewardPoints(userId: $userId, approvalStatus: $approvalStatus) {
      edges {
        node {
          id
          eventDate
          approvalStatus
          description
          points
          declinedReason
          discount {
            id
            maxUses
            numberOfUses
            code
            flatDiscount
          }
        }
      }
    }
  }
`;

export const CLIENT_INFORMATION_SHORT_QUERY = gql`
  query clientInformationShort($userId: ID!) {
    clientInformation(id: $userId) {
      id
      dateOfBirth
      phone
      lastActive
      hubspotContactVid
      user {
        id
        email
        firstName
        lastName
        username
        lastLogin
        dateJoined
      }
      country {
        name
        iocCode
        code
      }
    }
  }
`;

export const CLIENT_INFORMATION_DATA_QUERY = gql`
  query clientInformationDataQuery($userId: ID!) {
    clientInformation(id: $userId) {
      id
      dateOfBirth
      phone
      lastActive
      hubspotContactVid
      workoutsLoggedMonthAgo
      nutritionLoggedMonthAgo
      userStatus
      profilePicture
      lastAccountabilityGroup
      numberOfOpenDeals
      suburb
      taskPauseUntil
      taskPauseNote
      atRiskOnboarding
      gymBranch {
        id
        title
        gym {
          id
          title
        }
      }
      lastOneOnOneCoach {
        id
        firstName
        lastName
      }
      lastCompletedCheckIn {
        id
        assessmentDate
        nutritionRating
        nutritionComments
        rating
        comments
      }
      lastPayment {
        id
        discountAmount
        totalAmount
        billingDate
        discounts {
          edges {
            node {
              id
              code
            }
          }
        }
        order {
          id
          nextBillingDate
          subscriptionProductVariant {
            id
            title
            product {
              id
              code
            }
          }
        }
        transactionSet {
          id
          transactionStatus
          createdAt
        }
      }
      currentBlocks {
        id
        title
      }
      activeSubscription {
        id
        startDate
        endDate
        complementaryCategory {
          id
          title
        }
        coach {
          id
          firstName
          lastName
        }
        billingOrder {
          id
        }
        corporateChallenge {
          id
          title
        }
        product {
          id
          type
        }
      }
      nutritionCurrentBlock {
        id
        title
      }
      totalSpend
      weight
      desiredWeight
      occupation
      user {
        id
        email
        firstName
        lastName
        username
        lastLogin
        dateJoined
        usertagSet {
          id
          tag {
            id
            title
            code
          }
        }
      }
      country {
        name
        iocCode
        code
      }
    }
  }
`;

export const CLIENT_PROGRESS_QUERY = gql`
  query clientProgress($userId: ID!, $showAll: Boolean) {
    clientProgress(userId: $userId, showAll: $showAll) {
      username
      weeks
      exerciseDots
      nutritionDots
      mindsetDots
      weight
      weeklyWeight
      chest
      weeklyChest
      abdomen
      weeklyAbdomen
      hip
      weeklyHip
      quad
      weeklyQuad
      totalCm
      weeklyTotalCm
      frontImgFirst
      frontImgLast
      backImgFirst
      backImgLast
      sideImgFirst
      sideImgLast
      ratingFirst
      ratingLast
      nutritionRatingFirst
      nutritionRatingLast
      oneMile
      weeklyOneMile
      pushUps
      weeklyPushUps
      sitUps
      weeklySitUps
      burpeeChirpee
      weeklyBurpeeChirpee
      elbowPlank
      weeklyElbowPlank
      squat
      weeklySquat
    }
  }
`;

export const STAFF_QUERY = gql`
  query staffUsers($isActive: Boolean, $isStaff: Boolean, $userProfile_UserType: String) {
    users(isActive: $isActive, isStaff: $isStaff, userProfile_UserType: $userProfile_UserType) {
      edges {
        node {
          id
          firstName
          lastName
          email
          isStaff
          isActive
          userProfile {
            id
            profilePicture
            userType
          }
        }
      }
    }
  }
`;

export const ACCOUNT_QUERY = gql`
  query user($userId: ID!) {
    user(id: $userId) {
      id
      firstName
      lastName
      userProfile {
        id
        profilePicture
        phone
      }
    }
  }
`;

export const DEALS_QUERY = gql`
  query user($userId: ID!) {
    deals(userId: $userId) {
      edges {
        node {
          id
          closed
          name
          eventName
          hubspotContactVid
          hubspotDealId
          pipelineStage
          opportunity
          closeDate
          owner {
            id
            firstName
            lastName
          }
        }
      }
    }
  }
`;
export const STAFF_PROFILE_TASK_QUERY = gql`
  query clientsQuery($filterDate: Date) {
    clients(filterDate: $filterDate, user_IsStaff: true, teamId_Isnull: false) {
      edges {
        node {
          id
          totalClients
          assignedToIncompleteTasks
          tasksCompleted
          engagedClients
          messagesFromClients
          team {
            id
            name
          }
          user {
            id
            username
            firstName
            lastName
            email
          }
        }
      }
    }
  }
`;

export const OUTSTANDING_TODOS_QUERY = gql`
  query outstandingUserTodos($userId: ID) {
    outstandingUserTodos(userId: $userId) {
      id
      title
      shortDescription
      description
      url
      youtube
      loom
      type
    }
  }
`;

export const COMPLETED_TODOS_QUERY = gql`
  query completedTodosForUser($userId: ID) {
    completedTodosForUser(userId: $userId) {
      id
      title
      completedAt(userId: $userId)
      shortDescription
      description
      url
      youtube
      loom
      type
    }
  }
`;

export const RECURRING_TODOS_QUERY = gql`
  query recurringUserTodos($userId: ID, $anchorDate: Date!) {
    recurringUserTodos(userId: $userId, anchorDate: $anchorDate) {
      id
      title
      code
      shortDescription
      description
      url
      youtube
      loom
      type
      active
      scheduleType
      startDate
      endDate
      usertodoSet {
        id
        completedDate
        type
      }
    }
  }
`;

export const CLIENTS_SIMPLE_SEARCH_QUERY = gql`
  query clients(
    $firstName: String
    $lastName: String
    $userIdIn: [String]
    $userIsStaff: Boolean
    $search: String
    $first: Int
    $after: String
  ) {
    clients(
      user_FirstName_Icontains: $firstName
      user_LastName_Icontains: $lastName
      user_Id_In: $userIdIn
      user_IsStaff: $userIsStaff
      search: $search
      first: $first
      after: $after
    ) {
      pageInfo {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
      }
      edges {
        node {
          id
          profilePicture
          user {
            id
            firstName
            lastName
            email
            isStaff
          }
        }
      }
    }
  }
`;
